import InterestForm from './interestform'

export default InterestForm
